import { Link } from 'react-router-dom';
import './PolicyPages.css';

const TermsOfService = () => {
  return (
    <>
      {/* Page Title */}
      <div className="page-title-area ptb-100">
        <div className="container">
          <div className="page-title-content">
            <h1>Terms Of Service</h1>
            <ul>
              <li className="item"><Link to="/">Home</Link></li>
              <li className="item"><i className="flaticon-play-button"></i> Terms Of Service</li>
            </ul>
          </div>
        </div>
        <div className="bg-image">
          <img src="/assets/img/page-title/page-title-bg.jpg" alt="Terms of Service" />
        </div>
      </div>

      {/* Terms Content */}
      <section className="privacy-policy-area ptb-100">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-12">
              <div className="privacy-sidebar">
                <ul>
                  <li><Link to="/about">About Us</Link></li>
                  <li className="active"><Link to="/terms">Terms Of Service</Link></li>
                  <li><Link to="/privacy">Privacy And Policy</Link></li>
                </ul>
              </div>
            </div>
            
            <div className="col-lg-9 col-md-12">
              <div className="privacy-content">
                <p className="update-date">This Terms & Conditions was last updated on October, 2024.</p>
                
                <h2>Terms & Conditions</h2>
                <p>
                  This Website is made available to visitors by the group for imparting informations. This Website site is concrete facts not been reviewed or approved by any of our affiliates or group companies. This Website does not intend to provide investment, tax or legal advice or commitment or offer of any kind. None of the information or materials accessible through this Website should be construed as providing any type of investment or other advice to you. For should you consider anything on this Website as an offer, recommendation or solicitation to purchase or sell any financial security or to patronize, sell, lease, or provide any other goods or services.
                </p>

                <h3>Information we may collect from you</h3>
                <p>
                  The offer is in respect of units in the projects developed by Desale Patil Developers and their subsidiaries (Developer) which is open for limited period and it's Developer reserve the right to modify and or withdraw the same. The discounts & concessions shall be as per the predisigned policy of the Developer and the same will vary depending on the configuration or unit selected, time period of the booking, the terms of application form and agreement for sale. Price is exclusive of all taxes, statutory and other charges as applicable at the time of sale or registration and is subject to change.
                </p>

                <h3>Use of Website</h3>
                <p>
                  You agree to use this website only for lawful purposes and in a manner that does not infringe the rights of, or restrict or inhibit the use and enjoyment of this website by any third party.
                </p>

                <h3>Intellectual Property</h3>
                <p>
                  All content on this website, including but not limited to text, graphics, logos, images, and software, is the property of Desale Patil Developers and is protected by copyright and other intellectual property laws.
                </p>

                <h3>Limitation of Liability</h3>
                <p>
                  Desale Patil Developers shall not be liable for any direct, indirect, incidental, special, or consequential damages arising out of or in connection with your use of this website or the information contained herein.
                </p>

                <h3>Booking and Payment Terms</h3>
                <ul>
                  <li>All bookings are subject to availability and confirmation by Desale Patil Developers.</li>
                  <li>Payment schedules will be as per the agreement signed between the buyer and the developer.</li>
                  <li>All payments must be made through approved banking channels only.</li>
                  <li>Refund policy will be as per the terms mentioned in the booking agreement.</li>
                </ul>

                <h3>Cancellation Policy</h3>
                <p>
                  Cancellation terms and conditions will be governed by the agreement signed at the time of booking. Please refer to your booking agreement for specific cancellation policies.
                </p>

                <h3>Force Majeure</h3>
                <p>
                  Desale Patil Developers shall not be liable for any delay or failure in performance due to circumstances beyond its reasonable control, including but not limited to acts of God, war, terrorism, riots, strikes, government actions, or natural disasters.
                </p>

                <h3>Modifications to Terms</h3>
                <p>
                  We reserve the right to modify these terms and conditions at any time. Any changes will be posted on this page with an updated revision date.
                </p>

                <h3>Governing Law</h3>
                <p>
                  These terms and conditions shall be governed by and construed in accordance with the laws of India, and any disputes shall be subject to the exclusive jurisdiction of the courts in Nashik, Maharashtra.
                </p>

                <h3>Contact Information</h3>
                <p>
                  For any questions regarding these Terms of Service, please contact us:
                </p>
                <ul>
                  <li><strong>Email:</strong> info@desalepatil.in</li>
                  <li><strong>Phone:</strong> +91 9823020019</li>
                  <li><strong>Address:</strong> 5/6, Siddhi Park, New Pandit Colony, Gangapur Road, Nashik, Maharashtra</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TermsOfService;
